// =============================================================================
// NOTE — Modele de domaine frontend
// =============================================================================

export interface NoteAttachment {
  object_type: string;
  object_id: string;
  label?: string; // Resolu par le backend a la lecture
}

export interface NoteContext {
  objectType: string;
  objectId: string;
  objectLabel: string;
}

export interface AttachmentSearchGroup {
  object_type: string;
  object_type_label: string;
  object_type_icon: string;
  items: { object_id: string; label: string }[];
}

export interface NoteListResponse {
  data: Note[];
  total: number;
  limit: number;
  skip: number;
}

export class Note {
  note_id: string = "";
  eva_company_id: string = "";
  title: string = "";
  content: string = "";
  is_pinned: boolean = false;
  is_private: boolean = false;
  is_urgent: boolean = false;
  attachments: NoteAttachment[] = [];
  created_by: string = "";
  created_by_name: string = "";
  created_on: Date = new Date();
  updated_by: string = "";
  updated_by_name: string = "";
  updated_on: Date = new Date();

  static createInstance(data: any): Note {
    return Object.assign(new Note(), data);
  }

  static createInstances(data: any[]): Note[] {
    return data.map(Note.createInstance);
  }
}
